/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/Log.ts
 * @create:      2025-06-21 13:13:48.716
 * @modify:      2025-07-11 21:19:12.772
 * @version:     6.0.0
 * @times:       22
 * @lines:       88
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { AnsiTextColor } from "./Ansi";
import { FormatCurrentDate } from "./date/FormatCurrentDate";
import { DateTimeFormat } from "./enum/DateTimeFormat";
import { LogLevel } from "./enum/LogLevel";
import { ILogOptions } from "./interface/ILogOptions";

/**
 * @since 5.0.0
 * @version 2025-06-20
 */
export function FormatLog(message: string, level: LogLevel, options?: ILogOptions) {
    if (options?.Raw === true) {
        return message;
    }

    const renderColor = (data: string, color?: string) => {
        if (options?.NoColor === true) {
            return data;
        }

        if (color) {
            return AnsiTextColor(data, color);
        }

        return data;
    };

    const parts: string[] = [];

    if (options?.NoDateTime !== true) {
        let part = FormatCurrentDate(options?.DateTimeFormat ?? DateTimeFormat.FullDataTime);
        part = renderColor(part, options?.Colors?.DateTime);
        parts.push(`[${part}]`);
    }

    if (options?.NoLevel !== true) {
        let part = LogLevel[level];
        part = renderColor(part, options?.Colors?.Level);
        parts.push(`[${part}]`);
    }

    if (options?.Group && options?.NoGroup !== true) {
        let part = options.Group;
        part = renderColor(part, options?.Colors?.Group);
        parts.push(`[${part}]`);
    }

    message = renderColor(message, options?.Colors?.Message);
    parts.push(message);

    let log = parts.join("");
    log = renderColor(log, options?.Colors?.All);

    return log;
}
